import {Spin} from "antd";



const contentStyle = {
    padding: 50,
    borderRadius: 4,
};

const content = <div style={contentStyle} />;

const CustomLoader = () => {
    return (
        <Spin size="middle">
            {content}
        </Spin>
    );
}
export default CustomLoader;